/**
 * Parses a "W:H" aspect-ratio string (e.g. "2:3", "16:9", "1:1") into its
 * numeric axes. Shared by any component that accepts a target ratio as a
 * string prop (`schmancy-image-crop`, `schmancy-result-grid`) so the parse
 * + fallback rule lives once. A malformed or non-positive ratio degrades to
 * a safe 1:1 square rather than producing NaN layout.
 */
export function parseAspectRatio(ratio: string): readonly [number, number] {
	const [w, h] = ratio.split(':').map(Number)
	return w > 0 && h > 0 ? [w, h] : [1, 1]
}
